import socketIOClient from "socket.io-client";

export const socketBuilder = (brand: string, streamName: string) => {
  const websocketURL = process.env.REACT_APP_WEBSOCKET_URL;
  const environment = process.env.REACT_APP_ENVIRONMENT;

  const uri = `${websocketURL}?key=${brand}-${streamName}-${environment}&secret=true`;

  return socketIOClient(uri, {
    transports: ["websocket"],
    reconnection: true,
    reconnectionDelay: 1000,
    reconnectionAttempts: 30,
  });
};
